import * as angular from 'angular';
import contract from '../../service/contract/contract-module';
import sideMenuAdminController from './sideMenuAdminController';
import sideMenuController from './sideMenuController';
import topMenuController from './topMenuController';

export default angular.module('dataforvalter.menu', [contract])
    .controller('sideMenuAdminController', sideMenuAdminController)
    .controller('sideMenuController', sideMenuController)
    .controller('topMenuController', topMenuController)
    .name;
